<template>
  <div>
    <div
      v-show="displayCityVisible"
      class="flex items-center justify-between cursor-text"
      :class="{
        'py-2 px-4 rounded-lg lg:min-w-[440px] border-2': newSearchExperience,
        'mt-2': !newSearchExperience,
      }"
      :style="[
        newSearchExperience ? { backgroundColor: 'white', height: '50px' } : '',
      ]"
      @click.stop="handleChange"
      @keydown.stop="handleChange"
    >
      <p
        class="flex items-center justify-start space-x-2"
        :class="{
          'text-lg': size === 'xl',
          'text-sm': size !== 'xl',
        }"
      >
        <fa
          :icon="['fal', 'location-dot']"
          class="fa-fw"
          :class="{
            'text-lg': size === 'xl',
            'text-base': size !== 'xl',
            'text-indigo-400': newSearchExperience && !iconClass,
            'text-indigo-600': !newSearchExperience && !iconClass,
            iconClass,
          }"
        />
        <span
          :class="{
            'text-indigo-500 hover:text-indigo-700': !textClass,
            textClass,
          }"
          class="cursor-text"
        >
          {{ displayCity }}
        </span>
      </p>
    </div>
    <vetster-city-typeahead
      v-show="!displayCityVisible"
      ref="cityTypeahead"
      :geo="geo"
      :size="size"
      :filters="filters"
      :locale="locale"
      :countries="countries"
      :new-search-experience="newSearchExperience"
      @update="handleLocation"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import VetsterCityTypeahead from '@/components/VetsterCityTypeahead';

export default {
  name: 'VetsterSearchLocationPicker',

  components: { VetsterCityTypeahead },

  props: {
    location: {
      type: String,
      default: null,
    },
    filters: {
      type: [Object, Array],
      default: () => ({}),
    },
    locale: {
      type: String,
      default: 'en-US',
    },
    countries: {
      type: String,
      default: 'us',
    },
    size: {
      type: String,
      default: 'base',
    },
    newSearchExperience: {
      type: Boolean,
      default: false,
    },
    defaultInvisibleInput: {
      type: Boolean,
      default: false,
    },
    hideChange: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: '',
    },
    geo: {
      type: Object,
      default: null,
    },
    textClass: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      inputVisible: false,
    };
  },

  computed: {
    ...mapState('search', ['inputs']),

    ...mapGetters('search', ['displayCity']),

    ...mapGetters(['isGlobalUser']),

    displayCityVisible() {
      if (this.isGlobalUser) {
        return this.inputs.city && !this.inputVisible;
      }

      return this.inputs.province && !this.inputVisible;
    },
  },

  watch: {
    'inputs.city': {
      handler(city) {
        if (!city) return;
        this.$emit('location-updated');
        if (!this.defaultInvisibleInput) {
          this.inputVisible = false;
        }
      },
    },
  },

  mounted() {
    if (this.defaultInvisibleInput) {
      this.inputVisible = this.defaultInvisibleInput;
    }
  },

  methods: {
    async handleLocation(data) {
      await this.$store.commit('search/setInputs', {
        city: data.city,
        province: data.province,
        country: data.country,
      });
      this.$emit('location-selected');
    },

    async handleChange() {
      this.inputVisible = true;
      this.$emit('change');
      await this.$nextTick();
      this.$el.querySelector('.mapboxgl-ctrl-geocoder--input')?.focus();
    },
  },
};
</script>
